module.exports = __webpack_public_path__ + "img/idCardBack2.71ca66c1.png";